import type { ComponentPropsWithRef } from 'react'
import { cn } from '../../lib/cn.ts'

export interface IconButtonProps extends ComponentPropsWithRef<'button'> {
  /** Required: icon-only buttons need an accessible name. */
  'aria-label': string
  size?: 'md' | 'sm'
}

export function IconButton({ className, size = 'md', type = 'button', ...rest }: IconButtonProps) {
  return (
    <button
      type={type}
      className={cn(
        'inline-flex shrink-0 items-center justify-center rounded-ctl bg-transparent text-muted',
        'transition-colors hover:bg-surface-2 hover:text-text disabled:cursor-not-allowed disabled:opacity-50',
        size === 'sm' ? 'size-7 text-base' : 'size-8 text-lg',
        className,
      )}
      {...rest}
    />
  )
}
